export default "__VITE_ASSET__6d0a7732__"